export const FIREBASE_LOGIN = 'FIREBASE_LOGIN'
export const FIREBASE_UNAUTH = 'FIREBASE_UNAUTH'

export const SET_PLUGIN_SETTINGS = 'SET_PLUGIN_SETTINGS'

export const SIGNIN_GUEST = 'SIGNIN_GUEST'

export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_CURRENT_GUEST = 'SET_CURRENT_GUEST'
export const SET_CURRENT_CUSTOMER = 'SET_CURRENT_CUSTOMER'

export const SET_CURRENT_USER_PRESENCE = 'SET_CURRENT_USER_PRESENCE'
export const SET_CURRENT_USER_ACTIVITY = 'SET_CURRENT_USER_ACTIVITY'
export const MAKE_CURRENT_USER_ACTIVE = 'MAKE_CURRENT_USER_ACTIVE'
export const MAKE_CURRENT_USER_IDLE = 'MAKE_CURRENT_USER_IDLE'

export const SET_CHAT_SETTINGS = 'SET_CHAT_SETTINGS'

export const SET_USERS = 'SET_USERS'
export const SET_PRESENCES = 'SET_PRESENCES'
export const SET_USER_PRESENCE = 'SET_USER_PRESENCE'
export const SET_TOP_EXPERTS = 'SET_TOP_EXPERTS'

export const SET_USER = 'SET_USER'

export const SET_CONVERSATION_REFS = 'SET_CONVERSATION_REFS'
export const SET_RECENT_CONVERSATIONS = 'SET_RECENT_CONVERSATIONS'
export const SET_RECENT_CONVERSATION_USER = 'SET_RECENT_CONVERSATION_USER'
export const SET_CONVERSATION_STACK = 'SET_CONVERSATION_STACK'
export const SET_FOCUSED_CONVERSATION = 'SET_FOCUSED_CONVERSATION'
export const SET_LAST_OPEN_TIME_FOR_CONVERSATION = 'SET_LAST_OPEN_TIME_FOR_CONVERSATION'

export const SET_TOTAL_CONV_MESSAGE_COUNT = 'SET_TOTAL_CONV_MESSAGE_COUNT'
export const SET_READ_CONV_MESSAGE_COUNT = 'SET_READ_CONV_MESSAGE_COUNT'

export const SET_NEW_NOTIFICATION = 'SET_NEW_NOTIFICATION'
export const SET_NEW_MESSAGE_NOTIFICATION = 'SET_NEW_MESSAGE_NOTIFICATIONS'
export const SET_NEW_SESSION_REQUEST_NOTIFICATION = 'SET_NEW_SESSION_REQUEST_NOTIFICATION'
export const UNSET_NEW_MESSAGE_INDICATOR_ON_MOBILE = 'UNSET_NEW_MESSAGE_INDICATOR_ON_MOBILE'

export const SET_USER_SESSIONS = 'SET_USER_SESSIONS'
export const SET_USER_SESSION_REFS = 'SET_USER_SESSION_REFS'
export const SET_USER_SESSIONS_COUNT = 'SET_USER_SESSIONS_COUNT'
export const SET_CURRENT_SESSION = 'SET_CURRENT_SESSION'
export const REMOVE_USER_SESSION_REF = 'REMOVE_USER_SESSION_REF'
export const SET_SESSION_ACTIVITY = 'SET_SESSION_ACTIVITY'
export const SET_SESSION_REQUEST = 'SET_SESSION_REQUEST'
export const SET_SESSION_REQUESTS = 'SET_SESSION_REQUESTS'
export const SET_SESSION = 'SET_SESSION'
export const SET_SESSIONS = 'SET_SESSIONS'
export const SET_SESSION_CLAIMS = 'SET_SESSION_CLAIMS'

export const SET_NEW_MESSAGE = 'SET_NEW_MESSAGE'
export const SET_PREVIOUS_MESSAGES = 'SET_PREVIOUS_MESSAGES'
export const REMOVE_PREVIOUS_MESSAGES = 'REMOVE_PREVIOUS_MESSAGES'
export const UPDATE_MESSAGE_ATTR = 'UPDATE_MESSAGE_ATTR'

export const SHOW_MODAL = 'SHOW_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CLOSE_ALL_MODALS = 'CLOSE_ALL_MODALS'

export const SET_PAYOUTS = 'SET_PAYOUTS'
export const ORDER_PAYOUTS = 'ORDER_PAYOUTS'
export const SET_CURRENT_PAYOUT_REQUEST = 'SET_CURRENT_PAYOUT_REQUEST'
export const SET_CURRENT_USER_PAYOUTS = 'SET_CURRENT_USER_PAYOUTS'

export const SET_CURRENT_EXPERT_REVIEWS = 'SET_CURRENT_EXPERT_REVIEWS'

export const SET_USER_SCHEDULE = 'SET_USER_SCHEDULE'

export const SET_CHAT_LIST_TOGGLED = 'SET_CHAT_LIST_TOGGLED'

export const SET_CHAT_LIST_USER = 'SET_CHAT_LIST_USER'
export const REMOVE_CHAT_LIST_USER = 'REMOVE_CHAT_LIST_USER'
export const CHANGE_CHAT_LIST_USER_ROLE = 'CHANGE_CHAT_LIST_USER_ROLE'
export const SET_CHAT_LIST_GUESTS = 'SET_CHAT_LIST_GUESTS'

export const SET_GROUP_CHATS = 'SET_GROUP_CHATS'
export const SET_GROUP_CHAT = 'SET_GROUP_CHAT'
export const SET_GROUP_CHAT_ORDERS = 'SET_GROUP_CHAT_ORDERS'
export const SET_BOOKMARKED_GROUP_CHATS = 'SET_BOOKMARKED_GROUP_CHATS'
export const REMOVE_BOOKMARKED_GROUP_CHAT = 'REMOVE_BOOKMARKED_GROUP_CHAT'
export const SET_SUBSCRIBED_GROUP_CHATS = 'SET_SUBSCRIBED_GROUP_CHATS'
export const REMOVE_SUBSCRIBED_GROUP_CHAT = 'REMOVE_SUBSCRIBED_GROUP_CHAT'
export const SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT = 'SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT'
export const REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT = 'REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT'

export const SET_VIEWPORT_DIMENSIONS = 'SET_VIEWPORT_DIMENSIONS'

export const SET_ADVERTISEMENTS = 'SET_ADVERTISEMENTS'



/** WEBPACK FOOTER **
 ** ./modules/shared/data/action_types.js
 **/